import GATSBY_COMPILED_MDX from "/home/runner/work/kidz-dental-care/kidz-dental-care/src/content/patient-resources/dental-videos/index.mdx";
import React from 'react';
import {graphql} from 'gatsby';
import {DefaultLayout} from '../layouts/DefaultLayout';
import styled from '@emotion/styled';
import {MDXProvider} from '@mdx-js/react';
import {GatsbyImage, getImage} from 'gatsby-plugin-image';
import {MdxLink} from '../components/layout/Mdx-Link';
import {GroupedList} from '../components/layout/Grouped-List';
import {serviceCategories} from '../information';
import {CommonHero} from '../components/layout/Common-Hero';
import {DoctorPanels} from '../components/Doctor-Panels';
import {OurOutstandingStaff} from '../components/Our-Outstanding-Staff';
import {ButtonPrimary} from '../components/layout/StyledComponents';
import {Reviews} from '../components/Reviews';
import {FinancialPolicyItems} from '../components/Financial-Policy-Items';
import {PatientButtons} from '../components/Patient-Buttons';
import {AppointmentForm} from '../components/Appointment-Form';
import {OfficeTour} from '../components/Office-Tour';
import {Seo} from '../components/layout/Seo';
import image from '../images/myobrace-2.jpg';
import {ReactComponent as Mobile} from '../images/svgs/mobile.svg';
import {PatientForm} from './../components/PatientForm';
import {seoData} from '../components/layout/seoData';
const Template = (styled.div)`
    .myo-container {
        width: 100%;
        display: flex;
        justify-content: center;
    }
    .myo-logo {
        margin: 32px auto;
    }
`;
const Body = (styled.div)`
    margin-bottom: 64px;

    .mdx-image {
        margin: 32px auto;
        border-radius: 15px;
    }
    button {
        margin: 40.5px auto;
        a {
            text-decoration: none;
        }
    }
    h2 {
        color: #0096d7;
        margin-bottom: 16px;
        font-size: 28px;
    }
    h3 {
        font-size: 16px;
        color: ${({theme}) => theme.colors.gray5};
        margin-bottom: 16px;
        margin-top: 16px;
    }
    p {
        font-size: 16px;
    }
    a {
        text-decoration: underline;
        color: #0096d7;
        transition: color 0.2s ease-in-out;
        &:hover {
            color: #0b6b95;
        }
    }
    ul {
        padding-left: 20px;
        margin-bottom: 16px;
    }
    li {
        line-height: 26px;
        margin-bottom: 8px;
        color: #3d3c3a;
    }
    p {
        margin-bottom: 16px;
    }
    .section {
        margin-top: 32px;
        margin-bottom: 16px;
        a {
            position: relative;
            bottom: 12px;
        }
    }
    iframe {
        margin: 0 auto 40px;
        border-radius: 15px;
    }
    @media (min-width: 1130px) {
        display: flex;
        flex-direction: column;
        .mdx-image {
            width: 896px;
        }

        iframe {
            width: 100%;
            height: 509px;
        }
    }
`;
const StandardTemplate = ({data: {mdx: {frontmatter}, allMdx}, children}) => {
  const inlineImages = frontmatter.images?.map(img => getImage(img.childImageSharp));
  const Img = ({i, alt}) => React.createElement(GatsbyImage, {
    className: "mdx-image",
    image: inlineImages[i],
    alt: alt || ''
  });
  let links;
  if (frontmatter.general && frontmatter.type.toLowerCase() !== 'procedures') {
    links = [{
      name: frontmatter.title,
      path: `/${frontmatter.slug}`
    }];
  } else if (frontmatter.general && frontmatter.type.toLowerCase() === 'procedures') {
    links = [{
      name: frontmatter.type,
      path: `/${frontmatter.type}/`
    }, {
      name: frontmatter.title,
      path: `${frontmatter.slug}`
    }];
  } else if (!frontmatter.general && frontmatter.type.toLowerCase() === 'procedures') {
    const parts = frontmatter.slug.split('/');
    const parentSlug = `${parts[2]}`;
    links = [{
      name: frontmatter.type,
      path: `/${frontmatter.type}/`
    }, {
      name: frontmatter.category,
      path: `/procedures/${parentSlug}/`
    }, {
      name: frontmatter.title,
      path: `${frontmatter.slug}`
    }];
  } else {
    let parentSlug = frontmatter.slug.split('/')[1];
    links = [{
      name: frontmatter.type,
      path: `/${parentSlug}/`
    }, {
      name: frontmatter.title,
      path: `${frontmatter.slug}`
    }];
  }
  const shortCodes = {
    Img,
    MdxLink,
    DoctorPanels,
    OurOutstandingStaff,
    Reviews,
    ButtonPrimary,
    PatientButtons,
    PatientForm,
    OfficeTour,
    FinancialPolicyItems,
    AppointmentForm,
    Mobile
  };
  const serviceRenderTop = () => {
    if (frontmatter.general && frontmatter.category.toLowerCase() === 'all procedures') {
      return serviceCategories.map(category => {
        return React.createElement(GroupedList, {
          key: category,
          type: frontmatter.type,
          category: category,
          allMdx: allMdx,
          title: frontmatter.title
        });
      });
    } else if (frontmatter.general && frontmatter.category.toLowerCase() !== 'all procedures') {
      return React.createElement(GroupedList, {
        key: frontmatter.category,
        type: frontmatter.type,
        title: frontmatter.title,
        category: frontmatter.category,
        allMdx: allMdx
      });
    } else {
      return '';
    }
  };
  const serviceRenderBottom = () => {
    if (!frontmatter.general) {
      return React.createElement(GroupedList, {
        title: frontmatter.title,
        key: frontmatter.category,
        type: frontmatter.type,
        category: frontmatter.category,
        allMdx: allMdx
      });
    }
  };
  const pageName = frontmatter.slug.match(/\/([^\/]+)\/?$/)[1];
  const metaDescription = frontmatter.description || seoData[pageName] ? seoData[pageName].description : 'We provide exceptional kids dental care to Porter Ranch, Santa Clarita, Canyon Country Newhall, & Castaic communities and have experience serving children with special needs. Call us today!';
  return React.createElement(React.Fragment, null, React.createElement(Seo, {
    title: `${frontmatter.title} | Santa Clarita, California | Kidz Dental Care SCV and PR`,
    description: metaDescription
  }), React.createElement(Template, null, React.createElement(CommonHero, {
    title: frontmatter.title,
    featured_image: frontmatter.featured_image,
    links: links
  }), React.createElement("div", {
    className: "container"
  }, React.createElement("div", {
    className: "myo-container"
  }, frontmatter.title === 'MYOBRACE® at Porter Ranch' && React.createElement("img", {
    className: "myo-logo",
    src: image,
    alt: "myobrace certified"
  })), React.createElement(MDXProvider, {
    components: shortCodes
  }, serviceRenderTop(), React.createElement(Body, null, children), serviceRenderBottom()))));
};
export const query = graphql`
    query ($id: String!) {
        mdx(id: { eq: $id }) {
            frontmatter {
                title
                slug
                type
                category
                general
                featured_image {
                    id
                    childImageSharp {
                        gatsbyImageData(quality: 100, placeholder: NONE)
                    }
                    name
                }
                images {
                    id
                    childImageSharp {
                        gatsbyImageData(quality: 100, placeholder: NONE)
                    }
                    name
                }
            }
        }
        allMdx(
            filter: { frontmatter: { type: { ne: "office news" } } }
            sort: { frontmatter: { title: ASC } }
        ) {
            edges {
                node {
                    id

                    frontmatter {
                        title
                        slug
                        category
                        type
                        general
                        featured_image {
                            childImageSharp {
                                gatsbyImageData(quality: 80, placeholder: NONE)
                            }
                            name
                        }
                    }
                }
            }
        }
    }
`;
StandardTemplate.Layout = DefaultLayout;
StandardTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(StandardTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
